import { useState } from "react";
import BookingCalendar from "../components/BookingCalendar";

const Step1BookingInfo = ({
  form,
  setForm,
  promoters,
  artists,
  companies,
  onNext,
}) => {
  const [error, setError] = useState("");

  const validate = () => {
    if (
      !form.promoter ||
      !form.artist ||
      !form.artist_fee_company ||
      !form.booking_fee_company ||
      !form.booking_date
    ) {
      setError("All fields are required.");
      return false;
    }

    setError("");
    return true;
  };

  const handleNext = () => {
    if (!validate()) return;

    onNext();
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* LEFT SIDE */}
        <div className="space-y-6">
          {/* Promoter */}
          <div>
            <label className="text-sm text-slate-300">Select Promoter</label>

            <select
              value={form.promoter || ""}
              onChange={(e) => {
                setForm({ ...form, promoter: e.target.value });
                setError("");
              }}
              className="w-full bg-slate-900 border border-white/10 rounded-lg px-3 py-2 text-white"
            >
              <option value="">Select</option>

              {(promoters || []).map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>
          </div>

          {/* Artist */}
          <div>
            <label className="text-sm text-slate-300">Select Artist</label>

            <select
              value={form.artist || ""}
              onChange={(e) => {
                setForm({ ...form, artist: e.target.value });
                setError("");
              }}
              className="w-full bg-slate-900 border border-white/10 rounded-lg px-3 py-2 text-white"
            >
              <option value="">Select</option>

              {(artists || []).map((a) => (
                <option key={a.id} value={a.id}>
                  {a.real_name}
                </option>
              ))}
            </select>
          </div>

          {/* Artist Fee Company */}
          <div>
            <label className="text-sm text-slate-300">Artist Fee Company</label>

            <select
              value={form.artist_fee_company || ""}
              onChange={(e) => {
                setForm({ ...form, artist_fee_company: e.target.value });
                setError("");
              }}
              className="w-full bg-slate-900 border border-white/10 rounded-lg px-3 py-2 text-white"
            >
              <option value="">Select</option>

              {(companies || []).map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>

          {/* Booking Fee Company */}
          <div>
            <label className="text-sm text-slate-300">
              Booking Fee Company
            </label>

            <select
              value={form.booking_fee_company || ""}
              onChange={(e) => {
                setForm({ ...form, booking_fee_company: e.target.value });
                setError("");
              }}
              className="w-full bg-slate-900 border border-white/10 rounded-lg px-3 py-2 text-white"
            >
              <option value="">Select</option>

              {(companies || []).map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* RIGHT SIDE CALENDAR */}
        <div className="flex-1 bg-slate-900 rounded-xl border border-white/10">
          {/* <Calendar
          localizer={localizer}
          events={events}
          selectable
          style={{ height: 600 }}
          onSelectSlot={(slot) =>
            setForm({
              ...form,
              booking_date: slot.start,
            })
          }
        /> */}
          <BookingCalendar
            artistId={form.artist}
            selectedDate={form.booking_date}
            setSelectedDate={(date) => {
              setForm({ ...form, booking_date: date });
              setError("");
            }}
            //getArtistBookings={getArtistBookings}
          />
        </div>
      </div>

      <div className="flex flex-col items-center gap-3 pt-6">
        {error && <p className="text-red-400 text-sm">{error}</p>}

        <button
          onClick={handleNext}
          className="bg-pink-600 hover:bg-pink-700 px-10 py-3 rounded-lg text-white font-medium transition"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Step1BookingInfo;
